import { Component, Input, OnInit, OnChanges } from '@angular/core';

@Component({
    selector: 'client-contact-card',
    templateUrl: 'client-contact-card.component.html'
})
export class ClientContactCardComponent{
    @Input() contactCard: any;
}
